import './paggpixModal.scss';

import { Button, Container, Modal } from 'react-bootstrap';
import { FaCopy, FaKey } from 'react-icons/fa';
import { toast } from 'react-toastify';

import { useWebContext } from '@/resources/hooks/useWebContext';
import { maskMoney } from '@/services/global';
import { IShipmentPayment } from '@/store/ducks/order/types';

interface PixPaymentProps {
  show: boolean | undefined;
  onHide: () => void;
}

export function PaggpixPaymentMobile({ show, onHide }: PixPaymentProps) {
  const { order } = useWebContext();

  const { configs } = useWebContext();

  const companyImage = configs?.logo;

  const payment: IShipmentPayment | undefined = order?.payments?.find((p) => p.type === 'paggpix');

  const payment_qrcode = payment?.payment_qrcode || '';
  const total_paid = payment?.total_paid || 0;
  const pix_copy_code = payment?.pix_copy_code || '';

  const companyName = order?.company_name || '';
  const handleCopy = async () => {
    try {
      navigator.clipboard.writeText(pix_copy_code);
      toast.success('Código copiado com sucesso!');
    } catch (err) {
      toast.error('Erro ao copiar o código.');
      console.error(err);
    }
  };

  return (
    <Modal
      show={show || false}
      onHide={onHide}
      className="d-flex justify-content-center modal-mobile"
      centered
      size="sm"
    >
      <Modal.Header className="d-flex justify-content-center align-items-center">
        <label className="company-image text-center mb-0" title={companyName}>
          <img src={companyImage || ''} />
        </label>
      </Modal.Header>
      <Modal.Body className="p-0">
        <Container className="pix-container d-flex flex-column montserrat  align-items-center">
          <strong
            className="d-flex flex-row justify-content-start payment-title"
            style={{ fontSize: 20, width: '100%' }}
          >
            Pagamento
          </strong>

          <div className="details">
            Escaneie o quadrado ou copie o código abaixo para realizar o pagamento.
          </div>
          <div className="d-flex flex-column justify-content-start w-100 pt-3">
            <div className="details">Pedido #{order?.id || 'N/A'}</div>
            <div
              className="payment-price d-flex flex-row justify-content-start mt-0 ml-0 pl-0  "
              style={{ fontSize: 20, width: '100%' }}
            >
              <div className="details">
                Valor total:
                <strong className="value ml-2">{maskMoney(total_paid, true)}</strong>
              </div>
            </div>
          </div>
          <div className="qrcode-container justify-content-center text-center my-3">
            <img
              className="img-fluid"
              src={payment_qrcode}
              title={pix_copy_code}
              alt="payment_qrcode"
              style={{ maxWidth: 220 }}
            />
          </div>
          <div className="pix-key-container d-flex flex-column justify-content-start w-100 px-0">
            <div className="copy-and-paste d-flex flex-column align-items-center w-100 h-100">
              {' '}
              <div className="pix-key-label mb-1 mr-auto d-flex align-items-center">
                <div
                  className="key-icon"
                  style={{
                    backgroundColor: '#3070d9',
                    width: '2rem',
                    height: '2rem',
                    borderRadius: '40%',
                    justifyContent: 'center',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <FaKey color="white" />
                </div>
                <label className="key-label mb-0 ml-1">Pix copia e cola: </label>
              </div>
              <div
                className="copy-and-paste-code mt-2 border-primary w-100"
                style={{ userSelect: 'all', cursor: 'pointer' }}
                onClick={handleCopy}
                title="Clique para copiar"
              >
                <textarea
                  rows={3}
                  value={pix_copy_code}
                  readOnly
                  style={{ borderRadius: '0.5rem' }}
                  className="copy-and-paste-input border-primary w-100"
                />
              </div>
            </div>
          </div>
        </Container>
      </Modal.Body>
      <div className="d-flex justify-content-center mb-3">
        <Button
          className="copy-button justify-content-center align-items-center px-1 d-flex flex-row"
          onClick={handleCopy}
        >
          Copiar código
          <FaCopy className="ml-2" />
        </Button>
      </div>
    </Modal>
  );
}
